<div class="menu-item-container" cdkDropListOrientation="horizontal" cdkDropList (cdkDropListDropped)="drop($event)">
  <nav
    class="menu-item-container__item"
    *ngFor="let menuItem of menuItems; trackBy: menuItemTrackBy"
    cdkDrag
    mat-tab-nav-bar
    [cdkDragDisabled]="!editMode"
  >
    <mat-icon *ngIf="editMode" cdkDragHandle class="drag-icon">drag_indicator</mat-icon>
    <a
      mat-tab-link
      [routerLink]="menuItem.link"
      [class.disabled]="editMode"
      [routerLinkActiveOptions]="menuItem.linkOptions"
      [routerLinkActive]="'active'"
      [active]="menuItem.active"
      [disabled]="editMode"
      data-cy="tab-item-link"
      >{{ menuItem.displayText }}
      <span class="badge" *ngIf="menuItem.count > 0">{{ menuItem.count }}</span>
    </a>
    @if (menuItem.id && this.editMode && currentTabId !== menuItem.id) {
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon svgIcon="more_vert"></mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="more-menu">
        <button mat-menu-item (click)="editTabTitle(menuItem)">
          <mat-icon svgIcon="edit" class="mat-sm-icon edit-tab-title-control"></mat-icon>
          <span>Edit Tab Title</span>
        </button>
        <button mat-menu-item (click)="removeTab(menuItem)">
          <mat-icon svgIcon="delete" class="mat-sm-icon remove-tab-control"></mat-icon>
          <span>Remove Tab</span>
        </button>
        <button mat-menu-item (click)="duplicateTab(menuItem)">
          <mat-icon class="mat-sm-icon remove-tab-control">content_copy</mat-icon>
          <span>Duplicate Tab</span>
        </button>
      </mat-menu>
    }
  </nav>
  <button class="px-4" mat-button (click)="openTabPanel()" #tabPanelOrigin *ngIf="editMode">
    <mat-icon class="icon-size-20 mr-2" [svgIcon]="'add_circle'"></mat-icon>
    <span>Add Tab</span>
  </button>
  <button class="px-4" mat-button *ngIf="editMode" [matMenuTriggerFor]="addPanelMenu">
    <mat-icon class="icon-size-20 mr-2" [svgIcon]="'add_circle'"></mat-icon>
    <span>Add Panel</span>
  </button>
  <ng-template #tabPanel>
    <div class="tab-details-tags-panel">
      <div class="tags-panel-header flex items-center">
        <input [formControl]="tabName" type="text" placeholder="Tab Name" [maxLength]="25" />
        <button
          class="previous-button"
          type="submit"
          matTooltip="Save Tab"
          mat-icon-button
          (click)="addTab()"
          [disabled]="tabName.errors"
        >
          <mat-icon svgIcon="save"></mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
  <mat-menu #addPanelMenu="matMenu">
    <ng-container *ngFor="let panel of getPanels()">
      <button mat-menu-item (click)="addPanel(panel)">
        <mat-icon [svgIcon]="'add'"></mat-icon>
        <span>{{ panel.title }}</span>
      </button>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-menu>
</div>
